var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 12.6667C6.43337 11.5111 5.26404 10.3889 4.49204 9.30003C3.72004 8.21114 3.33382 7.14448 3.33337 6.10003C3.33337 5.31114 3.47515 4.61937 3.75871 4.0247C4.04226 3.43003 4.40582 2.93292 4.84937 2.53337C5.29382 2.13337 5.79382 1.83337 6.34937 1.63337C6.90493 1.43337 7.45515 1.33337 8.00004 1.33337C8.54448 1.33337 9.09449 1.43337 9.65004 1.63337C10.2056 1.83337 10.7056 2.13337 11.15 2.53337C11.5945 2.93337 11.9585 3.4307 12.242 4.02537C12.5256 4.62003 12.6672 5.31159 12.6667 6.10003C12.6667 7.14448 12.2805 8.21114 11.508 9.30003C10.7356 10.3889 9.56626 11.5111 8.00004 12.6667ZM8.00004 7.33337C8.36671 7.33337 8.68071 7.2027 8.94204 6.94137C9.20337 6.68003 9.33382 6.36625 9.33337 6.00003C9.33337 5.63337 9.20271 5.31937 8.94137 5.05803C8.68004 4.7967 8.36626 4.66625 8.00004 4.6667C7.63337 4.6667 7.31937 4.79737 7.05804 5.0587C6.79671 5.32003 6.66626 5.63381 6.66671 6.00003C6.66671 6.3667 6.79737 6.6807 7.05871 6.94203C7.32004 7.20337 7.63382 7.33381 8.00004 7.33337ZM3.33337 14.6667V13.3334H12.6667V14.6667H3.33337Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReAddress);
export default __webpack_public_path__ + "static/media/ReAddress.ff3f00bb9e3574a53654e7c6620952f7.svg";
export { ForwardRef as ReactComponent };